<!--详情页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogMachiningVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <div slot="title" style="display:flex;align-items:center;justify-content:center;gap:10px;">
      <span>{{getTitle()}} {{controlData.displayErpserial || controlData.erpserial}}</span>
      <el-tag v-if="auditMode" type="warning" size="small">待审核</el-tag>
    </div>
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"  class="print-table">
        <tr class="noborder">
          <td align="left" style="width: 90px;">单号：</td>
          <td>
            {{controlData.displayErpserial || controlData.erpserial}}
          </td>
          <td align="left" style="width: 90px;">仓&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td>
            {{controlData.cangkuname}}  {{controlData.warehousename}}
          </td>
          <td align="left" style="width: 90px;">处理方式：</td>
          <td>
            {{handlemode}}
          </td>
        </tr>
        <tr class="noborder" v-if="handlemode=='退回供应商'">
          <td align="left" style="width: 90px;"><span v-if="buyerpserial">退单号：</span></td>
          <td><span v-if="buyerpserial">{{buyerpserial}}</span>
          </td>
          <td align="left" style="width: 90px;">供应商：</td>
          <td>{{controlData.customername}}</td>
          <td align="left" style="width: 90px;" v-if="controlData.logisticsnum">快递单号：</td>
          <td v-if="controlData.logisticsnum">{{controlData.logisticsnum}}</td>
        </tr>
        <tr class="noborder" >
          <td></td>
          <td></td>
          <td></td>
          <td> </td>
          <td align="left"></td>
          <td>
            合计：{{totalnumber}}
          </td>
        </tr>
        <tr>
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td style="text-align: center;" v-show="showJingPian">R/L</td>
                <td style="text-align: center;">产品名称</td>
                <td style="text-align: center;" v-show="showJingPian">球镜</td>
                <td style="text-align: center;" v-show="showJingPian">柱镜</td>
                <td style="text-align: center;" v-show="showJingJia">型号</td>
                <td style="text-align: center;" v-show="showJingJia">色号</td>
                <td style="text-align: center;">销售单号</td>
                <td style="text-align: center;">采购单号</td>
                <td style="text-align: center;">数量</td>
              </tr>
              <tr v-for="item in tableData">
                <td style="text-align: center;" v-show="showJingPian">{{getPack(item.packagesize,'type',item.formproperty)}}</td>
                <td style="text-align: left;minWidth:150px">{{item.seedname}}<p v-if="item.subseedname" style="padding-left: 20px">{{item.subseedname}}</p></td>
                <td style="text-align: center;" v-show="showJingPian">{{getPack(item.packagesize,'Y')}}</td>
                <td style="text-align: center;" v-show="showJingPian">{{getPack(item.packagesize,'X')}}</td>
                <td style="text-align: center;" v-show="showJingJia">{{getPack(item.packagesize,'M')}}</td>
                <td style="text-align: center;" v-show="showJingJia">{{getPack(item.packagesize,'C')}}</td>
                <td style="text-align: center;"><span @click="lookdingdan(item)" style="cursor: pointer;">{{item.ordernum}}</span></td>
                <td style="text-align: center;">{{item.buyordernum}}</td>
                <td style="text-align: center;">{{item.totalnumber}}</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr style="height: 20px"></tr>
        <tr class="noborder">
          <td align="left">备注：</td>
          <td colspan="5" style="border: none;height: 30px">
            {{controlData.customername}}<br>
           {{controlData.remark}}
          </td>
        </tr>
        <tr style="height: 20px"></tr>
        <tr class="noborder">
          <td align="left">处理人：</td>
          <td>
            {{controlData.uname}}
          </td>
          <td align="left">出库日期：</td>
          <td>
            {{controlData.adddate}}
          </td>
        </tr>
      </table>
      <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
      <CstagreementEdit ref="DataContactEdit"></CstagreementEdit>
      <QRCodeScanBad ref="QRCodeScan1"></QRCodeScanBad>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogMachiningVisible = false;">关 闭</el-button>
      <el-button type="primary" @click="print1">打印</el-button>
      <el-button type="success" @click="delivergoodsScan" class="qrbtn" v-if="paramqrcodescan">唯一码</el-button>
      <el-checkbox v-model="supplybackorder" label="已发货给供应商" @change="changeFile" border v-if="buyerpserial&&buyerpserial.startsWith('32')&&!isprint"></el-checkbox>
    </div>
  </el-dialog>
</template>

<script>
  import {getByERPSerial} from '@/api/set/jxcstoreform';
  import {listSimple,saveCstagreementData} from '@/api/set/csagreement';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import BaoSunDetail from '../testorder/cstagreement/BaoSunDetail'
  import QRCodeScanBad from './QRCodeScanBad';
  import {checkModuleRight} from '@/api/login'

  export default {
    name: 'StorageBadOut',
    data() {
      return {
        msg: '坏件出库单',
        dialogMachiningVisible: false,
        formLabelWidth: '120px',
        controlData: {},
        handlemode:'',
        ordername:'',
        totalnumber:0,
        buyerpserial:'',
        buyunitguid:'',
        showtitle1:"none",
        isprint:false,
        tableData: [],
        showJingJia:false,
        showJingPian:false,
        supplybackorder:false,
        paramqrcodescan:false,
        auditMode:false,
      }
    },
    methods: {
      delivergoodsScan() {//扫码发货
        this.$refs.QRCodeScan1.show({
          cangkucode: this.controlData.cangkucode,
          erpserial: this.controlData.erpserial,
          seedcode: '',
        }, false);
      },
      print1() {
        this.isprint=true;
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
          this.isprint=false;
        })
      },
      changeFile() {
        if (!this.buyerpserial || !this.buyunitguid) return;
        saveCstagreementData({unitguid: this.buyunitguid, isfile: this.supplybackorder ? '10' : '0'}).then(response => {
          this.$message({
            message: '发货状态修改成功！',
            type: 'success'
          })
        })
      },
      getPack(packagesize,col,formproperty) {
        var v = '';

        if (packagesize) {
          v = JSON.parse(packagesize)[col];
          if(v==null)
            v='';
          else{
            if(col=='M')
              this.showJingJia=true;
            if(col=='Y')
              this.showJingPian=true;
          }
        }
        if(!v&&col=='type'&&formproperty){
          v = JSON.parse(formproperty)[0][col];
          if(v==null)
            v='';
        }
        return v;
      },
      getPackagesize(packagesize) {
        let s = ""
        if (packagesize) {
          let temp = JSON.parse(packagesize)
          s = "S:" + (parseFloat(temp.Y) > 0 ? "+" + temp.Y : temp.Y) + ",C:" + (parseFloat(temp.X) > 0 ? "+" + temp.X : temp.X)
          if (temp.type) {
            s = temp.type + " " + s
          }
        }
        return s
      },
      //查看订单
      lookdingdan(item) {
        if (item["ordernum"]) {
          var s = {
            erpserial: item["ordernum"]
          }
          this.$refs.DataContactEdit.initData(s)
          this.$refs.DataContactEdit.show()
        }
      },
      lookbaosundan(item){
        this.$refs.BaoSunDetail.show(item.erpserial,false)
      },
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "坏件出库单"
        return result
      },
      show(erpserial) {
        this.controlData = {}
        this.tableData = []
        this.dialogMachiningVisible = true;
        this.showJingJia=false;
        this.showJingPian=false;
        this.totalnumber=0;
        this.buyerpserial=''
        this.supplybackorder=false;
        this.auditMode=false;

        getByERPSerial({
          erpserial: erpserial,
          isout: "1"
        }).then(response => {
          if (response.data.code == 0) {
            this.controlData = response.data.main
            this.tableData = response.data.list
            this.auditMode = response.data.auditMode === true
            this.handlemode=this.tableData[0].handlemode
            for(let i in this.tableData){
              this.totalnumber+=parseFloat(this.tableData[i].totalnumber);
            }

            if(this.handlemode=='退回供应商'){
              this.buyerpserial= response.data.buyerpserial;
              if(this.buyerpserial){
                listSimple({erpserial:this.buyerpserial,notfilterindependent:'9'}).then(resBuy=>{
                  if(resBuy.data.obj&&resBuy.data.obj.length>0){
                    this.buyunitguid=resBuy.data.obj[0].unitguid;
                    if(resBuy.data.obj[0].isfile=='10'){
                      this.supplybackorder=true;
                    }
                  }
                })
              }
            }
          }
        })
      },
    },
    mounted() {
      checkModuleRight({name: 'qrcodescan'}).then(reponse => {//允许使用扫码发货
        this.paramqrcodescan = reponse.data.code == 0;
      });
    },
    components: {
      BaoSunDetail,
      CstagreementEdit,
      QRCodeScanBad
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>





// WEBPACK FOOTER //
// src/components/warehouse/StorageBadOut.vue